import React, { useState } from "react";
import { ButtonComp, ModalCompAdvanceUpdate } from "../../../components";
import { formatMoney } from "../../../utils";
import { useNavigate } from "react-router-dom";
import LoanCalculatorModal from "./LoanCalculator";
import { useGetMemberLoanSummaryQuery } from "../../../store/member/member-loan";

const LoanManagementCard = () => {
  const navigate = useNavigate();
  const [modalPage, setModalPage] = useState("");

  // Fetch loan summary from backend (backend calculates everything)
  const { data: loanSummary, isLoading: isLoadingLoanSummary } =
    useGetMemberLoanSummaryQuery();

  const totalLoanTaken = loanSummary?.loan_taken || 0;
  const paidPercent = loanSummary?.paid_percent || 0;

  const SummarySkeleton = () => (
    <div className="bg-white space-x-4 rounded-[0.625rem] shadow3 flex items-center pointer px-4 py-3 w-full">
      <div
        style={{
          width: "2.5rem",
          height: "2.5rem",
          borderRadius: "9999px",
          background: "#f1f1f1",
        }}
      />
      <div className="w-full space-y-2">
        <div
          style={{
            height: "22px",
            width: "40%",
            background: "#e5e5e5",
            borderRadius: "8px",
          }}
        />
        <div
          style={{
            height: "14px",
            width: "30%",
            background: "#f1f1f1",
            borderRadius: "6px",
          }}
        />
        <div
          className="progress w-full"
          style={{ height: "6px", background: "#f1f1f1" }}
        >
          <div
            className="progress-bar"
            role="progressbar"
            style={{ width: "0%", background: "#e0e0e0" }}
          />
        </div>
      </div>
    </div>
  );

  const useModal = [
    {
      name: "loan_calculator",
      component: <LoanCalculatorModal setModalPage={setModalPage} />,
    },
  ];
  return (
    <>
      <ModalCompAdvanceUpdate
        pageName={modalPage}
        arrayComp={useModal}
        handleClose={() => setModalPage()}
        centered
        size={"md"}
      />
      <div className="bg-[#000000] p-4 rounded-4  w-full space-y-6">
        {isLoadingLoanSummary ? (
          <SummarySkeleton />
        ) : (
          <div className="bg-white space-x-4 rounded-[0.625rem] shadow3 flex items-center pointer px-4 py-3  ">
            <img
              src="/MemberSide/Icons/dashboard2.svg"
              alt="img"
              className="w-[2.5rem] h-[2.5rem]"
            />

            <div className="w-full space-y- ">
              <h4 className="text-[#000] text-[1.375rem]  font-medium">
                {totalLoanTaken === 0
                  ? "₦0.00"
                  : formatMoney(totalLoanTaken, false, "₦")}
              </h4>
              <p
                className={` text-sm font-normal opacity-40 pb-2 pt-1 text-[#000]`}
              >
                Loan taken
              </p>
              <div
                className="progress w-full"
                style={{ height: "6px", background: "var(--color-primary-soft)" }}
              >
                <div
                  className="progress-bar "
                  role="progressbar"
                  aria-label="Loan repayment progress"
                  style={{
                    width: `${paidPercent}%`,
                    background: "var(--color-primary)",
                  }}
                  aria-valuenow={paidPercent}
                  aria-valuemin="0"
                  aria-valuemax="100"
                ></div>
              </div>
            </div>
          </div>
        )}
        <div className="flex space-x-5 " data-tour="member-loan-apply">
          <ButtonComp
            btnText={"Apply for loan"}
            onClick={() => navigate("/member/loan_management/application")}
            btnClassName=" bg-primary1 rounded py-2  w-full text-white font-semibold text-base"
          />
          <ButtonComp
            btnText={"Loan calculator"}
            onClick={() => setModalPage("loan_calculator")}
            btnClassName=" bg-primary1 rounded py-2 w-full text-white font-semibold text-base"
          />
        </div>
      </div>
    </>
  );
};

export default LoanManagementCard;
